import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { MailOutline } from '../shapes';


const MailOutlineSvg = (props) => (
  <g>
    <IconBounds />
    <MailOutline {...props} />
  </g>
);

MailOutlineSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

MailOutlineSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default MailOutlineSvg;
